export const config = {
  get env() {
    switch (window.location.hostname) {
      case 'admin.strideup.co':
      case 'broker-portal.prod.strideup.co':
        return {
          VITE_ENV: 'production',
          VITE_API_URL: 'https://api.prod.strideup.co',
          VITE_INTERMEDIARIES_URL: 'https://intermediaries.strideup.co/criteria',
          VITE_CLERK_PUBLISHABLE_KEY: 'pk_live_Y2xlcmsuYWRtaW4uc3RyaWRldXAuY28k',
          VITE_PUBLIC_POSTHOG_KEY: 'phc_9FydZhk0pAoCTOQgScacBE0iG1RXdBRnGD8e60v9I8m',
          VITE_PUBLIC_POSTHOG_HOST: 'https://eu.i.posthog.com',
        };
      case 'broker-portal.stg.strideup.co':
        return {
          VITE_ENV: 'staging',
          VITE_API_URL: 'https://api.stg.strideup.co',
          VITE_INTERMEDIARIES_URL: 'https://intermediaries.strideup.co/criteria',
          VITE_CLERK_PUBLISHABLE_KEY: 'pk_live_Y2xlcmsuYnJva2VyLXBvcnRhbC5zdGcuc3RyaWRldXAuY28k',
          VITE_PUBLIC_POSTHOG_KEY: 'phc_GWdoTh9IaQDhjTUz5EnjBlf9U8fnVnXSKgv6dGpt9nf',
          VITE_PUBLIC_POSTHOG_HOST: 'https://eu.i.posthog.com',
        };
      case 'broker-portal.dev.strideup.co':
        return {
          VITE_ENV: 'development',
          VITE_API_URL: 'https://api.dev.strideup.co',
          VITE_INTERMEDIARIES_URL: 'https://intermediaries.strideup.co/criteria',
          VITE_CLERK_PUBLISHABLE_KEY: 'pk_test_aG9wZWZ1bC1nbmF0LTM2LmNsZXJrLmFjY291bnRzLmRldiQ',
          VITE_PUBLIC_POSTHOG_KEY: 'phc_GWdoTh9IaQDhjTUz5EnjBlf9U8fnVnXSKgv6dGpt9nf',
          VITE_PUBLIC_POSTHOG_HOST: 'https://eu.i.posthog.com',
        };
      case 'localhost':
        return {
          VITE_ENV: 'development',
          VITE_API_URL: 'http://localhost:3333',
          VITE_INTERMEDIARIES_URL: 'https://intermediaries.strideup.co/criteria',
          VITE_CLERK_PUBLISHABLE_KEY: 'pk_test_aG9wZWZ1bC1nbmF0LTM2LmNsZXJrLmFjY291bnRzLmRldiQ',
          VITE_PUBLIC_POSTHOG_KEY: 'phc_GWdoTh9IaQDhjTUz5EnjBlf9U8fnVnXSKgv6dGpt9nf',
          VITE_PUBLIC_POSTHOG_HOST: 'https://eu.i.posthog.com',
        };
      default:
        console.error('Could not find an appropriate config for the current environment');
        return {};
    }
  },
  get isDev() {
    return this.env.VITE_ENV === 'development';
  },
  get isStg() {
    return this.env.VITE_ENV === 'staging';
  },
  get isLocalAuth() {
    return import.meta.env.VITE_USE_LOCAL_AUTH === 'true' && window.location.hostname === 'localhost';
  },
};
